<template>
  <!-- 车镇动态 -->
  <div class="box czdt">
    <div v-if="!isM" class="czdt_banner bgimg"></div>
    <div v-if="isM" class="czdtm_banner"></div>

    <div v-if="!isM" class="dt1">
      <div class="min_box" style="width: 1134px">
        <ul class="dt_ul">
          <div class="four_son" v-if="listLen >= 5">
            <li v-for="item in listfour" :key="item.id" @click="toDeatil(item)">
              <div class="hover_img">
                <img :src="item.thumb_url" alt="" />
              </div>
              <div class="dt_bottom">
                <p>{{ item.title }}</p>
                <span>{{ item.update_time }}</span>
              </div>
            </li>
          </div>
          <div v-if="listLen >= 5" style="display: inline">
            <li
              v-for="item in listthree"
              :key="item.id"
              class="to_big"
              @click="toDeatil(item)"
            >
              <div class="hover_img">
                <img :src="item.thumb_url" alt="" />
              </div>
              <div class="tb_box">
                <p>{{ item.title }}</p>
                <div class="dec">
                  {{ item.digest }}
                </div>
                <span>{{ item.update_time }}</span>
              </div>
            </li>
          </div>

          <li v-for="item in list" :key="item.id" @click="toDeatil(item)">
            <div class="hover_img">
              <img :src="item.thumb_url" alt="" />
            </div>
            <div class="dt_bottom">
              <p>{{ item.title }}</p>
              <span>{{ item.update_time }}</span>
            </div>
          </li>
        </ul>
        <a
          class="loading_more"
          v-if="nomore && !loadingShow"
          href="javascript:void(0)"
          @click="loadingMore"
          >加载更多</a
        >

        <Loading :show="loadingShow" />
      </div>
    </div>

    <div v-if="isM" class="dt1">
      <ul class="dt_ul">
        <li v-for="item in list" :key="item.id" @click="toDeatil(item)">
          <div class="hover_img">
            <img :src="item.thumb_url" alt="" />
          </div>
          <div class="dt_bottom">
            <p>{{ item.title }}</p>
            <span>{{ item.update_time }}</span>
          </div>
        </li>
      </ul>
      <Loading :show="loadingShow" />
      <p class="over_load" v-if="!nomore">—— 加载完毕 ——</p>
    </div>
  </div>
</template>

<script>
import { getCzDynamicList } from "@/api/all";
import Loading from "@/components/loading";
export default {
  name: "Privatedire",
  components: {
    Loading,
  },
  data() {
    return {
      data: {
        page: 0,
        limit: 12,
      },
      listLen: 0,
      list: [],
      listfour: [],
      listthree: [],
      nomore: true,
      loadingShow: false,
      isM: false,
      totalNum: 0,
    };
  },
  created() {
    this.isM = JSON.parse(sessionStorage.getItem("isM"));
    if (this.isM == true) {
      this.getCzListm();
      window.addEventListener("scroll", this.handleScroll);
    } else {
      this.getCzList();
    }
  },
  methods: {
    getCzListm() {
      getCzDynamicList({
        page: 0, //每次数据开始的位置
        limit: 10,
      }).then((response) => {
        this.totalNum = 10;
        var arr = response.data.list;
        arr.length == 0 ? (this.nomore = false) : (this.nomore = true);
        this.list = this.list.concat(response.data.list);
      });
    },
    getCzList() {
      getCzDynamicList({
        page: 0, //每次数据开始的位置
        limit: 7,
      }).then((response) => {
        this.totalNum = 7;
        var arr = response.data.list;
        arr.length == 0 ? (this.nomore = false) : (this.nomore = true);
        this.listLen = arr.length;
        if (arr.length >= 5) {
          this.listfour = arr.slice(0, 4);
          this.listthree = arr.slice(4, 7);
          this.list = arr.slice(7);
        } else {
          this.list = arr;
        }
      });
    },
    loadingMore() {
      if (this.nomore == false) return false;
      this.loadingShow = true;
      this.data.page = this.totalNum;
      getCzDynamicList(this.data).then((response) => {
        let arr = response.data.list;
        this.totalNum += this.data.limit;
        arr.length == 0 ? (this.nomore = false) : (this.nomore = true);
        this.list = this.list.concat(arr);
        this.loadingShow = false;
      });
    },
    handleScroll() {
      let scrolltop =
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        window.pageYOffset;

      if (
        (scrolltop + document.documentElement.clientHeight >=
          document.documentElement.scrollHeight - 313) &
        this.nomore
      ) {
        if (!this.loadingShow) {
          if (this.nomore == false) return false;
          this.loadingShow = true;
          getCzDynamicList({
            page: this.totalNum,
            limit: 10,
          }).then((response) => {
            this.totalNum += 10;
            let arr = response.data.list;
            arr.length == 0 ? (this.nomore = false) : (this.nomore = true);
            this.list = this.list.concat(response.data.list);
            this.loadingShow = false;
          });
        }
      }
    },
    toDeatil(item) {
      if (item.is_wechat == 1) {
        window.open(item.url, "_blank");
      } else {
        let link = this.$router.resolve({
          path: "/Czarticle",
          query: {
            title: item.title,
            data: item.content,
          },
        });
        window.open(link.href, "_blank");
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Cartownnews/Cartownnews.vue